import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-ivory/70 border-t border-ivory/10"
    >
      <div className="container-editorial py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-2xl text-ivory">Manuel Faustini</span>
            <span className="text-[10px] tracking-[0.3em] uppercase text-goldSoft font-semibold">
              CFA
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-ivory/60">
            Consulente finanziario autonomo iscritto all'Albo OCF. Servizio fee-only,
            indipendente, fiduciario.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline text-goldSoft mb-4">Naviga</p>
          <ul className="space-y-2 text-sm">
            {[
              ["chi-sono", "Chi sono"],
              ["servizi", "Servizi"],
              ["approccio", "Approccio"],
              ["risultati", "Risultati"],
              ["faq", "FAQ"],
              ["contatti", "Contatti"],
            ].map(([id, lbl]) => (
              <li key={id}>
                <a
                  data-testid={`footer-link-${id}`}
                  href={`#${id}`}
                  className="hover:text-ivory link-underline"
                >
                  {lbl}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline text-goldSoft mb-4">Contatti</p>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                data-testid="footer-email"
                href="mailto:faustinimanuelcfa@gmail.com"
                className="hover:text-ivory"
              >
                faustinimanuelcfa@gmail.com
              </a>
            </li>
            <li>Studio · Bergamo</li>
            <li>Videocall · tutta Italia</li>
          </ul>

          <p className="overline text-goldSoft mb-4 mt-8">Legale</p>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                data-testid="footer-privacy"
                to="/privacy"
                className="hover:text-ivory link-underline"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-cookie"
                to="/cookie"
                className="hover:text-ivory link-underline"
              >
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-acf"
                to="/acf"
                className="hover:text-ivory link-underline"
              >
                Arbitro Controversie Finanziarie
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-precontrattuale"
                to="/precontrattuale"
                className="hover:text-ivory link-underline"
              >
                Informativa Precontrattuale
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-sostenibilita"
                to="/sostenibilita"
                className="hover:text-ivory link-underline"
              >
                Informativa Sostenibilità
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="container-editorial py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-ivory/45">
          <p>
            © {new Date().getFullYear()} Manuel Faustini · Tutti i diritti riservati
          </p>
          <p>Iscrizione OCF · P.IVA IT0463717160</p>
        </div>
      </div>
    </footer>
  );
};
